/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { certificateAdminControllerCreateV1 } from '../fn/certificate-admin/certificate-admin-controller-create-v-1';
import { CertificateAdminControllerCreateV1$Params } from '../fn/certificate-admin/certificate-admin-controller-create-v-1';
import { certificateAdminControllerDeleteV1 } from '../fn/certificate-admin/certificate-admin-controller-delete-v-1';
import { CertificateAdminControllerDeleteV1$Params } from '../fn/certificate-admin/certificate-admin-controller-delete-v-1';
import { certificateAdminControllerFindAllV1 } from '../fn/certificate-admin/certificate-admin-controller-find-all-v-1';
import { CertificateAdminControllerFindAllV1$Params } from '../fn/certificate-admin/certificate-admin-controller-find-all-v-1';
import { certificateAdminControllerFindByIdV1 } from '../fn/certificate-admin/certificate-admin-controller-find-by-id-v-1';
import { CertificateAdminControllerFindByIdV1$Params } from '../fn/certificate-admin/certificate-admin-controller-find-by-id-v-1';
import { certificateAdminControllerReorderV1 } from '../fn/certificate-admin/certificate-admin-controller-reorder-v-1';
import { CertificateAdminControllerReorderV1$Params } from '../fn/certificate-admin/certificate-admin-controller-reorder-v-1';
import { certificateAdminControllerSearchCursorV1 } from '../fn/certificate-admin/certificate-admin-controller-search-cursor-v-1';
import { CertificateAdminControllerSearchCursorV1$Params } from '../fn/certificate-admin/certificate-admin-controller-search-cursor-v-1';
import { certificateAdminControllerSearchOffsetV1 } from '../fn/certificate-admin/certificate-admin-controller-search-offset-v-1';
import { CertificateAdminControllerSearchOffsetV1$Params } from '../fn/certificate-admin/certificate-admin-controller-search-offset-v-1';
import { certificateAdminControllerUpdateV1 } from '../fn/certificate-admin/certificate-admin-controller-update-v-1';
import { CertificateAdminControllerUpdateV1$Params } from '../fn/certificate-admin/certificate-admin-controller-update-v-1';
import { CertificateDto } from '../models/certificate-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class CertificateAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `certificateAdminControllerFindAllV1()` */
  static readonly CertificateAdminControllerFindAllV1Path = '/api/v1/certificates/admin';

  /**
   * 인증서/특허 전체 조회 (관리자).
   *
   * 인증서/특허 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `certificateAdminControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  certificateAdminControllerFindAllV1$Response(params?: CertificateAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CertificateDto>>> {
    const obs = certificateAdminControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 인증서/특허 전체 조회 (관리자).
   *
   * 인증서/특허 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `certificateAdminControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  certificateAdminControllerFindAllV1(params?: CertificateAdminControllerFindAllV1$Params, context?: HttpContext): Observable<Array<CertificateDto>> {
    const resp = this.certificateAdminControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<CertificateDto>>): Array<CertificateDto> => r.body)
    );
  }

  /** Path part for operation `certificateAdminControllerCreateV1()` */
  static readonly CertificateAdminControllerCreateV1Path = '/api/v1/certificates/admin';

  /**
   * 인증서/특허 생성.
   *
   * 인증서/특허을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `certificateAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  certificateAdminControllerCreateV1$Response(params: CertificateAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CertificateDto>> {
    const obs = certificateAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 인증서/특허 생성.
   *
   * 인증서/특허을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `certificateAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  certificateAdminControllerCreateV1(params: CertificateAdminControllerCreateV1$Params, context?: HttpContext): Observable<CertificateDto> {
    const resp = this.certificateAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CertificateDto>): CertificateDto => r.body)
    );
  }

  /** Path part for operation `certificateAdminControllerSearchOffsetV1()` */
  static readonly CertificateAdminControllerSearchOffsetV1Path = '/api/v1/certificates/admin/search/offset';

  /**
   * 인증서/특허 오프셋 기반 조회 (관리자).
   *
   * 인증서/특허을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `certificateAdminControllerSearchOffsetV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  certificateAdminControllerSearchOffsetV1$Response(params: CertificateAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<CertificateDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = certificateAdminControllerSearchOffsetV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 인증서/특허 오프셋 기반 조회 (관리자).
   *
   * 인증서/특허을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `certificateAdminControllerSearchOffsetV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  certificateAdminControllerSearchOffsetV1(params: CertificateAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<{
'items': Array<CertificateDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.certificateAdminControllerSearchOffsetV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<CertificateDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<CertificateDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `certificateAdminControllerSearchCursorV1()` */
  static readonly CertificateAdminControllerSearchCursorV1Path = '/api/v1/certificates/admin/search/cursor';

  /**
   * 인증서/특허 커서 기반 조회 (관리자).
   *
   * 인증서/특허을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `certificateAdminControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  certificateAdminControllerSearchCursorV1$Response(params: CertificateAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<CertificateDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>> {
    const obs = certificateAdminControllerSearchCursorV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 인증서/특허 커서 기반 조회 (관리자).
   *
   * 인증서/특허을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `certificateAdminControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  certificateAdminControllerSearchCursorV1(params: CertificateAdminControllerSearchCursorV1$Params, context?: HttpContext): Observable<{
'items': Array<CertificateDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}> {
    const resp = this.certificateAdminControllerSearchCursorV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<CertificateDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
}>): {
'items': Array<CertificateDto>;

/**
 * 다음 페이지의 커서 값
 */
'nextCursor'?: string | null;

/**
 * 다음 페이지 존재 여부
 */
'hasNext': boolean;
} => r.body)
    );
  }

  /** Path part for operation `certificateAdminControllerFindByIdV1()` */
  static readonly CertificateAdminControllerFindByIdV1Path = '/api/v1/certificates/admin/{id}';

  /**
   * 인증서/특허 상세 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `certificateAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  certificateAdminControllerFindByIdV1$Response(params: CertificateAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CertificateDto>> {
    const obs = certificateAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 인증서/특허 상세 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `certificateAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  certificateAdminControllerFindByIdV1(params: CertificateAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<CertificateDto> {
    const resp = this.certificateAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CertificateDto>): CertificateDto => r.body)
    );
  }

  /** Path part for operation `certificateAdminControllerDeleteV1()` */
  static readonly CertificateAdminControllerDeleteV1Path = '/api/v1/certificates/admin/{id}';

  /**
   * 인증서/특허 삭제.
   *
   * 인증서/특허을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `certificateAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  certificateAdminControllerDeleteV1$Response(params: CertificateAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CertificateDto>> {
    const obs = certificateAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 인증서/특허 삭제.
   *
   * 인증서/특허을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `certificateAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  certificateAdminControllerDeleteV1(params: CertificateAdminControllerDeleteV1$Params, context?: HttpContext): Observable<CertificateDto> {
    const resp = this.certificateAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CertificateDto>): CertificateDto => r.body)
    );
  }

  /** Path part for operation `certificateAdminControllerUpdateV1()` */
  static readonly CertificateAdminControllerUpdateV1Path = '/api/v1/certificates/admin/{id}';

  /**
   * 인증서/특허 수정.
   *
   * 인증서/특허을(를) 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `certificateAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  certificateAdminControllerUpdateV1$Response(params: CertificateAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CertificateDto>> {
    const obs = certificateAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 인증서/특허 수정.
   *
   * 인증서/특허을(를) 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `certificateAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  certificateAdminControllerUpdateV1(params: CertificateAdminControllerUpdateV1$Params, context?: HttpContext): Observable<CertificateDto> {
    const resp = this.certificateAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CertificateDto>): CertificateDto => r.body)
    );
  }

  /** Path part for operation `certificateAdminControllerReorderV1()` */
  static readonly CertificateAdminControllerReorderV1Path = '/api/v1/certificates/admin/reorder';

  /**
   * 인증서/특허 순서 변경.
   *
   * 인증서/특허의 순서를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `certificateAdminControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  certificateAdminControllerReorderV1$Response(params: CertificateAdminControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = certificateAdminControllerReorderV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 인증서/특허 순서 변경.
   *
   * 인증서/특허의 순서를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `certificateAdminControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  certificateAdminControllerReorderV1(params: CertificateAdminControllerReorderV1$Params, context?: HttpContext): Observable<void> {
    const resp = this.certificateAdminControllerReorderV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
